export default "__VITE_ASSET__np7aHoV$__"